import { tryAxios } from '@/api/common/auth'
import { urlPrefix } from '@/configs/api'
const apiUrl = `${urlPrefix}/UnitDevice`
//#region 基本信息
const GetList = `${apiUrl}`
const GetStatusList = `${apiUrl}/GetStatus`
const GetByUnit = (id: number) => `${apiUrl}/list/${id}`
const GetPoints = (id: number) => `${apiUrl}/points/${id}`
const GetPoint = (id: number) => `${apiUrl}/point/${id}`
const GetPointTypeList = `${apiUrl}/GetPointTypes`
const GetInfo = (id: number) => `${apiUrl}/${id}`
const ViewInfo = (id: number) => `${apiUrl}/view/${id}`
const PostData = `${apiUrl}`
const PutData = (id: number) => `${apiUrl}/${id}`
const Delete = (id: number) => `${apiUrl}/${id}`
//#endregion

export const emptyData: UnitDeviceData = {
    Id: 0,
    UnitId: 0,
    DeviceCategoryId: 0,
    DeviceNumber: '',
    DeviceSerialId: '',
    DeviceBrand: 0,
    DeviceAliase: '',
    DeviceModuleDriver: 0,
    DeviceDescription: '',
    DevicePostionName: '',
    DeviceStatus: 0,
    DeviceIp: '',
    DevicePort: '',
    AccessUser: '',
    AccessPwd: '',
    NewUserId: 0,
    NewDate: new Date(),
    UpdateUserId: 0,
    UpdateDate: new Date(),

    UnitCode: '',
    UnitName: '',
    CategoryName: '',
    BrandName: '',
    DriverName: '',
    UserName: '',
    PointList: []
}
export interface UnitDeviceData {
    [key: string]: any
    Id: number
    UnitId: number
    DeviceCategoryId: number
    DeviceNumber: string
    DeviceSerialId: string
    DeviceBrand: number
    DeviceAliase: string
    DeviceModuleDriver: number
    DeviceDescription: string
    DevicePostionName: string
    DeviceStatus: number
    DeviceIp: string
    DevicePort: string
    AccessUser: string
    AccessPwd: string
    NewUserId: number
    NewDate: Date
    UpdateUserId: number
    UpdateDate: Date

    UnitCode: string
    UnitName: string
    CategoryName: string
    BrandName: string
    DriverName: string
    UserName: string
    PointList: UnitDevicePointData[]
}

export const emptyPoint: UnitDevicePointData = {
    Id: 0,
    DeviceId: 0,
    PointName: '',
    PointAliaseName: '',
    PointNum: 0,
    PointType: '',
    PointValueType: 0,
    PointValueUnit: 0,
    ScopeValueLow: 0,
    ScopeValueHigh: 0,
    PointDeviateScope: '',
    Status: 1,
    NewUserId: 0,
    NewDate: new Date(),
    UpdateUserId: 0,
    UpdateDate: new Date(),

    ValueTypeName: '',
    ValueUnitName: '',
    UserName: '',

    // AttachType: 0,
    // AttachGuid: ''
}
export interface UnitDevicePointData {
    [key: string]: any
    Id: number
    DeviceId: number
    PointName: string
    PointAliaseName: string
    PointNum: number
    PointType: string
    PointValueType: number
    PointValueUnit: number
    ScopeValueLow: number
    ScopeValueHigh: number
    PointDeviateScope: string
    Status: number
    NewUserId: number
    NewDate: Date
    UpdateUserId: number
    UpdateDate: Date

    ValueTypeName: string
    ValueUnitName: string
    UserName: string

    // AttachType: number
    // AttachGuid: string
}
export const removeData = (id: number) => {
    return tryAxios({
        method: 'delete',
        url: Delete(id)
    })
}
export const getStatusList = (firstType: number) => {
    return tryAxios({
        method: 'get',
        url: GetStatusList,
        params: { type: firstType }
    })
}
export const getPointTypes = (firstType: number) => {
    return tryAxios({
        method: 'get',
        url: GetPointTypeList,
        params: { type: firstType }
    })
}
export const getList = (param: any) => {
    return tryAxios({
        method: 'get',
        url: GetList,
        params: param
    })
}
export const getByUnit = (unitId: number) => {
    return tryAxios({
        method: 'get',
        url: GetByUnit(unitId),
    })
}
export const getPoints = (unitDeviceId: number) => {
    return tryAxios({
        method: 'get',
        url: GetPoints(unitDeviceId),
    })
}
export const getInfo = (id: number) => {
    return tryAxios({
        method: 'get',
        url: GetInfo(id),
    })
}
export const viewInfo = (id: number) => {
    return tryAxios({
        method: 'get',
        url: ViewInfo(id),
    })
}
export const getPoint = (id: number) => {
    return tryAxios({
        method: 'get',
        url: GetPoint(id),
    })
}
export const postData = (form: UnitDeviceData) => {
    return tryAxios({
        method: 'post',
        url: PostData,
        data: form
    })
}
export const putData = (id: number, form: UnitDeviceData) => {
    return tryAxios({
        method: 'put',
        url: PutData(id),
        data: form
    })
}
